/** The provider rejected the booking (BM status CX/ER): nothing was booked. */
export class HotelBookingRejectedError extends Error {
  constructor() {
    super('hotels.booking.error.bookingRejected');
    this.name = 'HotelBookingRejectedError';
  }
}

/**
 * We cannot tell whether the booking was made: the backend got no answer from the provider
 * (BOOKING_OUTCOME_UNKNOWN) or our own request to the backend was cut. Retrying could book
 * twice, so the user is told not to retry — the agency verifies it.
 */
export class HotelBookingUnverifiedError extends Error {
  constructor() {
    super('hotels.booking.error.bookingUnverified');
    this.name = 'HotelBookingUnverifiedError';
  }
}
